// P3-004: Enemy type configurations (GDD section 4.5.6)

export interface EnemyTypeConfig {
  type: 'STANDARD' | 'IMPATIENT' | 'LEGACY';
  hpMultiplier: number;
  description: string;
  mechanic?: EnemyMechanic;
}

export interface EnemyMechanic {
  type: 'DEADLINE_REDUCE' | 'TILE_CD_INCREASE';
  /** For IMPATIENT: every N turns, deadline-1 */
  interval?: number;
  /** For LEGACY: duration in turns of tile move CD+1 */
  duration?: number;
}

/** HP threshold event configurations */
export interface HPThresholdEvent {
  /** HP percentage at which this event triggers (0-1) */
  threshold: number;
  phase: 'demand-change-light' | 'demand-change-heavy';
  /** Damage reduction multiplier (e.g., 0.15 = 15% less damage) */
  damageReduction: number;
  /** How many turns this effect lasts */
  duration: number;
  /** Number of tiles to lock (only for heavy) */
  lockTiles: number;
  message: string;
}

// ─── Enemy Type Configs ─────────────────────────────────

export const ENEMY_TYPE_CONFIGS: Record<string, EnemyTypeConfig> = {
  STANDARD: {
    type: 'STANDARD',
    hpMultiplier: 1.0,
    description: '标准外包项目，无特殊机制',
  },
  IMPATIENT: {
    type: 'IMPATIENT',
    hpMultiplier: 0.8,
    description: '创业公司急躁客户，每4回合deadline-1',
    mechanic: {
      type: 'DEADLINE_REDUCE',
      interval: 4,
    },
  },
  LEGACY: {
    type: 'LEGACY',
    hpMultiplier: 1.3,
    description: '祖传代码重构，初始3回合tile移动CD+1',
    mechanic: {
      type: 'TILE_CD_INCREASE',
      duration: 3,
    },
  },
};

// ─── HP Threshold Events ────────────────────────────────

export const HP_THRESHOLD_EVENTS: HPThresholdEvent[] = [
  {
    threshold: 0.66,
    phase: 'demand-change-light',
    damageReduction: 0.15,
    duration: 2,
    lockTiles: 0,
    message: '[CLIENT] 能不能加个小功能...',
  },
  {
    threshold: 0.33,
    phase: 'demand-change-heavy',
    damageReduction: 0.25,
    duration: 3,
    lockTiles: 3,
    message: '[CLIENT] 我觉得整个方案要改...',
  },
];

// ─── Overload Probability by Level ──────────────────────

export const OVERLOAD_PROBABILITY: Record<string, number> = {
  none: 0,
  light: 5,
  medium: 15,
  heavy: 30,
};
